import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';

interface IImage {
    ContentType: string;
    Image: string;
}

/**
 * TanStack Query version of useQueryImage
 * Fetches image data using HTTP client with parameter-based reactivity
 */
const useQueryImage = (imageId: string | null) => {
  const httpClient = useHttpClient();

  return useQuery<IImage>({
    queryKey: ['image', imageId],
    queryFn: async () => {
      if (!imageId) {
        throw new Error('Image ID not set');
      }
      const response = await httpClient.get(imageId);
      return response.data;
    },
    enabled: imageId !== null, // Only fetch when image ID is provided
  });
};

export default useQueryImage;
